<template>
  <svg
    class="circle-chart"
    viewbox="0 0 50 50"
    width="50"
    height="50"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      class="circle-chart__background"
      stroke-width="6"
      fill="none"
      cx="25"
      cy="25"
      :r="radius"
    />
    <circle
      class="circle-chart__circle"
      fill="none"
      stroke-width="6"
      :stroke-dasharray="getRadiusPosition"
      stroke-linecap="round"
      cx="25"
      cy="25"
      :r="radius"
    />
    <g class="circle-chart__info">
      <text
        class="circle-chart__percent"
        x="25"
        y="25"
        alignment-baseline="central"
        text-anchor="middle"
      >
        {{ activeStep }}/{{ totalStep }}
      </text>
    </g>
  </svg>
</template>
<script>
export default {
  name: 'StepProgress',
  props: {
    activeStep: {
      type: Number,
      default: () => 1,
    },
    totalStep: {
      type: Number,
      default: () => 4,
    },
  },
  data () {
    return {
      radius: 22,
    };
  },
  computed: {
    getRadiusPosition () {
      const total = (this.radius * 3.14) * 2;
      const active = (total / this.totalStep) * this.activeStep;
      return `${active},${total}`;
    },
  },
};
</script>

<style lang="scss" scoped>
  .circle-chart{
    &__background{
      stroke: rgb(222, 224, 235);
    }
    &__circle {
      transform: rotate(-90deg);
      transform-origin: center;
      stroke: rgb(11, 193, 92);
    }
    &__info {
      font-weight: 500;
      font-size: 14px;
    }
  }
</style>
